import { Component, OnInit } from '@angular/core';
import { FormRepository } from '../../Repositories/form.repository';
import * as _ from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
    ColDef,
    GridApi,
    GridOptions,
    GridReadyEvent,
    CsvExportParams,
    ApplyColumnStateParams
} from 'ag-grid-community';
import { AgGridOptionsBuilder } from '../../AgGrid/agGridOptionsBuilder';
import { AgGridFilterParams, AgGridColumns } from '../../AgGrid';
import { IWeissmanModalComponent } from '../../WeissmanModalService';
import { FormService } from '../form.service';
import { AgGridLinkCellRendererComponent, AgGridLinkCellRendererParams } from '../../AgGrid/CellRenderers/agGridLinkCellRenderer.component';

@Component({
    selector: 'form-appeals-list',
    templateUrl: './formAppealsList.component.html',
    styleUrls: ['./formAppealsList.component.scss'],
    standalone: false
})

export class FormAppealsListComponent implements OnInit, IWeissmanModalComponent<void, void> {
    constructor(
        private readonly _formRepository: FormRepository,
        private readonly _formService: FormService,
        private readonly _bsModalRef: BsModalRef) {
    }

    params: void;
    result: void;

    isBusy: boolean = false;
    gridApi: GridApi;
    gridOptions: GridOptions = new AgGridOptionsBuilder()
        .withContext(this)
        .withLoadingOverlay()
        .withFloatingFilter()
        .withMultipleColumnSort()
        .withColumnResize()
        .withTextSelection()
        .build();

    private _appeals: Compliance.FormRevisionAppealInfoModel[];

    get headerLabel(): string {
        return `In-Use Appeals for ${this._formService.formRevision.name} in Tax Year ${this._formService.formRevisionYear.taxYear}`;
    }

    async ngOnInit(): Promise<void> {
        this.isBusy = true;

        try {
            this._appeals = await this._formRepository.getAppeals(this._formService.formRevision.formRevisionId, this._formService.formRevisionYear.taxYear);
            this._setRowData();
        } finally {
            this.isBusy = false;
        }
    }

    onAgGridReady(event: GridReadyEvent): void {
        this.gridApi = event.api;

        const columns: ColDef[] = [
            {
                headerName: 'Appeal ID',
                field: 'appealId',
                filter: 'agTextColumnFilter',
                filterParams: AgGridFilterParams.textFilterParams,
                floatingFilterComponentParams: AgGridFilterParams.textFloatingFilterParams,
                width: AgGridColumns.textColumnWidth,
                cellRenderer: AgGridLinkCellRendererComponent,
                                cellRendererParams: {
                                    getHelpContentId: (params: AgGridLinkCellRendererParams) => 'app.view-appeal',
                                    newWindow: true,
                                    getLink: (params: AgGridLinkCellRendererParams) => {
                                        const appeal = params.data as Compliance.FormRevisionAppealInfoModel;
                                        if (!(appeal && appeal.appealId)) {
                                            return '';
                                        }
                                        return `#/appeal/${appeal.appealId}`;
                                    },
                                    isDisabled: (params: AgGridLinkCellRendererParams) => {
                                        const appeal = params.data as Compliance.FormRevisionAppealInfoModel;
                                        return !(appeal && appeal.appealId);
                                    }
                                } as AgGridLinkCellRendererParams
            },
            {
                headerName: 'Progress Status',
                field: 'progressStatus',
                filter: 'agTextColumnFilter',
                filterParams: AgGridFilterParams.textFilterParams,
                floatingFilterComponentParams: AgGridFilterParams.textFloatingFilterParams,
                width: AgGridColumns.textColumnWidth,
            },
            {
                headerName: 'Appeal Level',
                field: 'appealLevelAbbr',
                filter: 'agTextColumnFilter',
                filterParams: AgGridFilterParams.textFilterParams,
                floatingFilterComponentParams: AgGridFilterParams.textFloatingFilterParams,
                width: AgGridColumns.textColumnWidth,
            }
        ];

        const defaultSortModel: ApplyColumnStateParams = {
            state: [{ colId: 'displayId', sort: 'asc' }],
            defaultState: { sort: null }
        };

        this.gridApi.setGridOption('columnDefs', columns);
        this.gridApi.applyColumnState(defaultSortModel);
        this._setRowData();
    }

    cancel(): void {
        this._bsModalRef.hide();
    }

    export(): void {
        const params = {
            fileName: 'FormAppeals.csv'
        } as CsvExportParams;
        this.gridApi.exportDataAsCsv(params);
    }

    private _setRowData() {
        if (!(this.gridApi && this._appeals)) {
            return;
        }

        this.gridApi.setGridOption('rowData', this._appeals);
        this.gridApi.sizeColumnsToFit();
    }
}
